import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '~/components/legal-page'
import { getPublicConfig } from '~/functions/session.functions'
import { privacySections } from '~/lib/legal'

export const Route = createFileRoute('/privacy')({
  loader: () => getPublicConfig(),
  head: () => ({ meta: [{ title: `${m.legal_privacy_title()} - ${m.app_name()}` }] }),
  component: PrivacyPage,
})

/** The privacy policy: public, readable without an account. */
function PrivacyPage() {
  const { company } = Route.useLoaderData()
  return (
    <LegalPage
      title={m.legal_privacy_title()}
      sections={privacySections(company)}
      company={company}
    />
  )
}
